import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import style from "./style.module.css";
import { EntAnimalPepublicResponse, EntRegionAnimals, EntAnimalInfo } from '../api/types';
import { ResponseDataGet } from '../../../../models/responseDataGet';

interface MainTableProps {
    data?: ResponseDataGet<EntAnimalPepublicResponse>;
    isLoading?: boolean;
}

interface RegionWithExpanded extends EntRegionAnimals {
    expanded?: boolean;
    percentage?: number;
}

export const MainTable: React.FC<MainTableProps> = ({ data, isLoading }) => {
    const { t } = useTranslation();
    const [regionsData, setRegionsData] = useState<RegionWithExpanded[]>([]);

    React.useEffect(() => {
       
        console.log("API data:", data);
        
        if (data?.res?.data && Array.isArray(data.res.data)) {
            const initialRegions = data.res.data.map(region => ({
                ...region,
                expanded: false,
                percentage: region.percentage
            }));
            
            setRegionsData(initialRegions);
        } 
        else if (data?.res?.content && data.res.content.length > 0) {
            const firstItem = data.res.content[0] as EntAnimalPepublicResponse;
            
            if (firstItem && firstItem.data && Array.isArray(firstItem.data)) {
                
                const initialRegions = firstItem.data.map(region => ({
                    ...region,
                    expanded: false,
                    percentage: region.percentage
                }));
                
                setRegionsData(initialRegions);
                console.log("Region data from content ready:", initialRegions.length, "items");
            } else {
                console.log("No data array found in the API response");
            }
        } else {
            console.log("No data in response");
        }
    }, [data]);


    const totalAnimals = data?.res ? (data.res as any).total || 0 : 0;


    const toggleRegion = (index: number) => {
        const updatedRegions = [...regionsData];
        updatedRegions[index].expanded = !updatedRegions[index].expanded;
        setRegionsData(updatedRegions);
    };

    return (
        <div className={style.tableContainer}>
            <h3 className={style.tableTitle}>{t('Данные по республике')}</h3>
            <p className={style.totalCount}>{t('Всего животных')}: {totalAnimals.toLocaleString()}</p>

            <table className={style.mainTable}>
                <thead>
                    <tr>
                        <th className={style.areaColumn}>{t('Регион')}</th>
                        <th className={style.countColumn}>{t('Количество')}</th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading ? (
                        <tr>
                            <td colSpan={2} style={{ textAlign: 'center', padding: '20px' }}>
                                {t('Загрузка...')}
                            </td>
                        </tr>
                    ) : regionsData && regionsData.length > 0 ? (
                        regionsData.map((region, index) => (
                            <React.Fragment key={`region-group-${index}`}>
                                <tr className={style.regionRow}>
                                    <td className={style.regionCell}>
                                        <span
                                            className={style.expandButton}
                                            onClick={() => toggleRegion(index)}
                                        >
                                            {region.expanded ? '−' : '+'}
                                        </span>
                                        {region.nameRu || region.nameKy}
                                    </td>
                                    <td className={style.countCell}>
                                        {region.amount.toLocaleString()} {region.percentage !== undefined && (
                                            <span style={{ color: '#888', fontSize: '12px' }}>
                                                ({region.percentage.toFixed(1)}%)
                                            </span>
                                        )}
                                    </td>
                                </tr>
                                {region.expanded && region.animals?.map((animal, subIndex) => (
                                    <tr key={`subitem-${index}-${subIndex}`} className={style.subItemRow}>
                                        <td className={style.subItemCell}>{animal.animalNameRu || animal.animalNameKy}</td>
                                        <td className={style.countCell}>{animal.totalHeadCount.toLocaleString()}</td>
                                    </tr>
                                ))}
                            </React.Fragment>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={2} style={{ textAlign: 'center', padding: '20px' }}>
                                {t('Данных нет')}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}